/* global google, GMaps */
import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import qs from 'qs';
import * as constants from '../../util/constants';
import helpers from '../../util/helpers';

const MapSkeleton = () => {
  return (
    <div className="map-wrapper skeleton-shine" />
  );
};

const ThingsToDoSkeleton = () => {
  return (
    <Fragment>
      <div className="map-wrapper-col col-span-1 md:col-span-3">
        <div id="things-to-do-results-block-map-wrapper" className="skeleton-shine" />
      </div>
      {
        Array.from(Array(9).keys()).map((i) => {
          return (
            <div key={i} className="col-span-1">
              <div className="things-to-do-item skeleton">
                <div className="things-to-do-item-image-wrapper skeleton-shine" />
                <div className="things-to-do-item-title skeleton-shine" />
                <div className="things-to-do-item-date skeleton-shine" />
              </div>
            </div>
          );
        })
      }
    </Fragment>
  );
};

class AppThingsToDo extends Component {
  constructor(props) {
    super(props);

    // Initial state
    this.initialState = {
      loading: true,
      thingsToDoCount: 0,
      allThingsToDo: [],
      allThingToDoLocations: [],
      loadMoreLoading: false,
      loadedAll: false,
    };

    // Assign first state
    this.state = Object.assign({}, this.initialState);

    this.type = '';

    const type = helpers.getParameterByName('type');
    if (type != null && type.length) {
      this.type = type;
    }

    // Bind "this"
    this.handleLoadMoreThingsToDoOnWindowEvents = this.handleLoadMoreThingsToDoOnWindowEvents.bind(this);
    this.loadThingsToDo = this.loadThingsToDo.bind(this);
    this.loadMoreThingsToDo = this.loadMoreThingsToDo.bind(this);
    this.loadMap = this.loadMap.bind(this);

    // Cancel token source
    this.source = axios.CancelToken.source();
  }

  componentDidMount() {
    this.loadThingsToDo();

    $(document).on(constants.EVENT_THINGS_TO_DO_TYPE_FILTER_CHANGED, (e, type) => {
      if (this.type !== type) {
        this.type = type;
        this.loadThingsToDo();
      }
    });

    helpers.onWindowEvents(this.handleLoadMoreThingsToDoOnWindowEvents, 0, 1, 1, 1);
  }

  componentDidUpdate(_, prevState) {
    if (
      (prevState.loading && !this.state.loading) ||
      (prevState.loadMoreLoading && !this.state.loadMoreLoading)
    ) {
      this.loadMap();
    }
  }

  handleLoadMoreThingsToDoOnWindowEvents() {
    const {
      loading,
      loadMoreLoading,
      loadedAll,
    } = this.state;

    if (!loading && !loadMoreLoading && !loadedAll) {
      const triggerElement = $('#load-more-things-to-do-trigger');
      const elementTop = triggerElement.offset().top;
      const elementBottom = elementTop + triggerElement.outerHeight();
      const viewHeight = $(window).height();
      const scrollTop = $(document).scrollTop();
      const scrollBottom = scrollTop + viewHeight;

      if (elementBottom > scrollTop && elementTop < scrollBottom) {
        this.loadMoreThingsToDo();
      }
    }
  }

  loadThingsToDo() {
    // Reset state
    this.setState(this.initialState);

    // Params
    const data = {
      'action': constants.ACTION_GET_THINGS_TO_DO,
      'type': this.type,
      'offset': 0,
    };

    // Send request
    axios.post(window.IndCollStandalone['ajaxUrl'], qs.stringify(data), {
      cancelToken: this.source.token,
    }).then((axiosResponse) => {
      if (200 === axiosResponse.status) {
        const response = axiosResponse.data;

        if (response.success) {
          const thingsToDoCount = response.data['things_to_do_count'];
          const thingsToDo = response.data['things_to_do'];
          const thingToDoLocations = response.data['thing_to_do_locations'];

          if (thingsToDoCount > 0) {
            this.setState({
              loading: false,
              loadMoreLoading: false,
              thingsToDoCount,
              allThingsToDo: [...thingsToDo],
              allThingToDoLocations: [...thingToDoLocations],
              loadedAll: parseInt(thingsToDoCount) === thingsToDo.length,
            });
          } else {
            this.setState({
              loading: false,
              thingsToDoCount: 0,
              allThingsToDo: [],
              allThingToDoLocations: [],
              loadMoreLoading: false,
              loadedAll: true,
            });
          }
        } else {
          this.setState({
            loading: false,
            thingsToDoCount: 0,
            allThingsToDo: [],
            allThingToDoLocations: [],
            loadMoreLoading: false,
            loadedAll: true,
          });
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  loadMoreThingsToDo() {
    const {
      allThingsToDo,
      loadedAll,
    } = this.state;

    if (!loadedAll) {
      this.setState({
        loading: false,
        loadMoreLoading: true,
      });

      // Params
      const data = {
        'action': constants.ACTION_GET_THINGS_TO_DO,
        'type': this.type,
        'offset': allThingsToDo.length,
      };

      // Send request
      axios.post(window.IndCollStandalone['ajaxUrl'], qs.stringify(data), {
        cancelToken: this.source.token,
      }).then((axiosResponse) => {
        if (200 === axiosResponse.status) {
          const response = axiosResponse.data;

          if (response.success) {
            const thingsToDoCount = response.data['things_to_do_count'];
            const thingsToDo = [
              ...allThingsToDo,
              ...response.data['things_to_do'],
            ];

            if (thingsToDoCount > 0) {
              this.setState({
                loading: false,
                allThingsToDo: [...thingsToDo],
                loadMoreLoading: false,
                loadedAll: parseInt(thingsToDoCount) === thingsToDo.length,
              });
            } else {
              this.setState({
                loading: false,
                loadMoreLoading: false,
                loadedAll: true,
              });
            }
          } else {
            this.setState({
              loading: false,
              loadMoreLoading: false,
              loadedAll: true,
            });
          }
        }
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  loadMap() {
    if ($('#things-to-do-results-block-map-wrapper').length) {
      const { allThingToDoLocations } = this.state;
      if (allThingToDoLocations.length > 0) {
        // Setup first item on map
        const map = new GMaps({
          div: '#things-to-do-results-block-map-wrapper',
          scrollwheel: false,
          center: new google.maps.LatLng(allThingToDoLocations[0]['address']['lat'], allThingToDoLocations[0]['address']['lng']),
          zoom: 15,
        });

        const mapMarkerInfoWindowTemplate = $('#things-to-do-results-block-map-marker-info-window').html();
        const bounds = [];

        for (let i = 0; i < allThingToDoLocations.length; i++) {
          if (Object.keys(allThingToDoLocations[i]['address']).length > 0) {
            const title = allThingToDoLocations[i]['title'];
            const lat = allThingToDoLocations[i]['address']['lat'];
            const lng = allThingToDoLocations[i]['address']['lng'];
            const link = allThingToDoLocations[i]['link'];

            bounds.push(new google.maps.LatLng(lat, lng));

            map.addMarker({
              lat: lat,
              lng: lng,
              title: title,
              icon: {
                scaledSize: new google.maps.Size(44, 44),
                url: allThingToDoLocations[i]['address']['marker_image'],
              },
              infoWindow: {
                content: helpers.transformMapMarkerInfoWindow({
                  title,
                  address: allThingToDoLocations[i]['address']['address'],
                  link,
                }, mapMarkerInfoWindowTemplate),
              },
            });
          }
        }

        if (allThingToDoLocations.length > 1) {
          map.fitLatLngBounds(bounds);
        }
      }
    }
  }

  render() {
    const {
      loading,
      allThingsToDo,
      loadMoreLoading,
    } = this.state;

    return (
      <Fragment>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-y-20">
          <div className="map-wrapper-col col-span-1 md:col-span-3">
            {
              (!loading && allThingsToDo.length > 0) && (
                <div id="things-to-do-results-block-map-wrapper" className="map-wrapper" />
              )
            }
            {
              loading && (
                <MapSkeleton />
              )
            }
          </div>
          {
            (!loading && allThingsToDo.length > 0) && (
              <Fragment>
                {
                  allThingsToDo.map((thingsToDo, i) => {
                    return (
                      <div key={i} className="col-span-1">
                        <a href={thingsToDo['link']} className="things-to-do-item">
                          <div className="things-to-do-item-image-wrapper">
                            {
                              thingsToDo['image'] && (
                                <img src={thingsToDo['image']}
                                    className="things-to-do-item-image"
                                    loading="lazy"
                                    decoding="async"
                                    alt=""
                                />
                              )
                            }
                            {
                              thingsToDo['type'] && (
                                <div className="things-to-do-item-type" style={thingsToDo['type_color'] ? {backgroundColor:thingsToDo['type_color']} : {}}>
                                  {thingsToDo['type']}
                                </div>
                              )
                            }
                          </div>
                          {
                            thingsToDo['title'] && (
                              <div className="things-to-do-item-title">
                                {thingsToDo['title']}
                                <div className="title-icon" dangerouslySetInnerHTML={{__html: window.IndCollStandalone['assets']['arrowRight']}} />
                              </div>
                            )
                          }
                          {
                            thingsToDo['date_label'] && (
                              <div className="things-to-do-item-date">
                                { thingsToDo['date_label'] }
                              </div>
                            )
                          }
                        </a>
                      </div>
                    );
                  })
                }
              </Fragment>
            )
          }
          {
            (!loading && allThingsToDo.length === 0) && (
              <div className="col-span-1 md:col-span-2">
                <h3 className="text-center">No results found</h3>
              </div>
            )
          }
          {
            (loading || loadMoreLoading) && (
              <ThingsToDoSkeleton />
            )
          }
        </div>
      </Fragment>
    );
  }
}

export default {
  init() {
  },
  finalize() {
    // Render results
    const thingsToDoWrapper = $('#things-to-do-wrapper');
    if (thingsToDoWrapper.length) {
      ReactDOM.render(<AppThingsToDo />, thingsToDoWrapper[0]);
    }

    const thingsToDoTypesFilter = $('#things-to-do-types-filter');
    if (thingsToDoTypesFilter.length) {
      thingsToDoTypesFilter.on('select2:select', function () {
        const _this = $(this);
        const selectedVal = _this.val();
        const params = helpers.getParameters();

        if (selectedVal !== '') {
          params['type'] = selectedVal;
        } else {
          delete params['type'];
        }

        // Push params to url
        helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

        $(document).trigger(constants.EVENT_THINGS_TO_DO_TYPE_FILTER_CHANGED, [selectedVal]);
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/acf-blocks/thingsToDoResults.js